import React, { Component } from 'react';
import Dropzone from 'react-dropzone';

class UploadPhotos extends Component {
    handleDrop = (acceptedFiles) => {
        this.props.onFilesAdded(acceptedFiles);
    };

    render() {
        const { uploadedImages, onRemoveImage } = this.props;

        return (
            <div className="mb-3">
                <Dropzone
                    onDrop={this.handleDrop}
                    multiple
                    accept="image/*"
                    maxSize={15000000} 
                >
                    {({ getRootProps, getInputProps }) => (
                        <div
                            {...getRootProps()}
                            className="d-flex flex-column align-items-center jobs-dropzone p-3 border border-dashed"
                            style={{ cursor: 'pointer' }}
                        >
                            <input {...getInputProps()} />
                            <p className="mb-0 text-muted">
                                Drag & drop images here, or click to select
                            </p>
                        </div>
                    )}
                </Dropzone>

                {uploadedImages.length > 0 && (
                    <div className="d-flex flex-wrap mt-2">
                        {uploadedImages.map((img, idx) => (
                            <div
                                key={idx}
                                style={{ marginRight: '10px', position: 'relative' }}
                            >
                                <img
                                    src={img}
                                    alt={`receipt-${idx}`}
                                    className="img-thumbnail"
                                    style={{ height: '80px' }}
                                />
                                <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    style={{ position: 'absolute', top: 0, right: 0 }}
                                    onClick={() => onRemoveImage(idx)}
                                >
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default UploadPhotos;